import React from 'react'
import {render} from 'react-dom'
import { isEqual } from 'lodash'

import moment from 'moment'

import { setAuthorizationToken, setDeviceToken } from './utils/setAuthorizationToken'
import { isLoginFromShopOwner, isLoginFromChainOrSuper } from './utils/auth'
import { setCurrentUser, logOutAs, logout, setDepartmentType } from './actions/auth'
import { getBrowserName } from './utils/detect'

import { Router, browserHistory } from 'react-router'

// Redux
import { Provider } from 'react-redux'
import { syncHistoryWithStore } from 'react-router-redux'
import EventEmitter from './utils/events'
import store from './store'

import UploadOverlay from './shared/components/UploadOverlay'

// import I18n from './language'

// Toastr
window.toastr.options.progressBar = true
window.toastr.options.positionClass = 'toast-bottom-right'
window.toastr.options.newestOnTop = false

// Lightbox
window.lightbox.option({
  albumLabel: '%1 / %2'
})

// Moment
moment.locale('en', {
  week: {
    dow: 1
  }
})

// Sockets
let sockUrl = process.env.SOCKET_SERVER
let sock = new window.ReconnectingWebSocket(sockUrl, null, {
  debug: false,
  reconnectInterval: 3000
})

sock.OPEN = 1
window.sock = sock
sock.onopen = (e) => {
  console.log('[app][sock.onopen]', sock)
  if (window.localStorage.user_data || window.localStorage.loginAsUser) {
    // Connect to socket
    setTimeout(() => {
      if (window.sock.readyState === window.sock.OPEN) {
        let shopId = JSON.parse(window.localStorage.user_data).ShopId
        if (parseInt(shopId) === 0 && window.localStorage.loginAsUser) {
          shopId = JSON.parse(window.localStorage.loginAsUser).ShopId
        }
        window.sock.send(JSON.stringify({
          Type: 'RECONNECT',
          ShopId: parseInt(shopId)
        }))
      }
    }, 3000)
  }
}

sock.onmessage = (e) => {
  let json = JSON.parse(e.data)
  // console.log('[app][sock.onmessage]', json)
  switch (json.Type) {
    case 'HEADER_INFO_MESSAGES':
    case 'HEADER_INFO_EVALUATION':
    case 'HEADER_INFO_UPDATES':
    case 'HEADER_INFO_FORSI':
    case 'HEADER_INFO_CHAINNOTIFICATION':
      EventEmitter.emit('HEADER_INFO', json)
      break
    case 'ORDER_UPDATE':
    case 'ORDER_LINKED':
    case 'ORDER_CREATED':
    case 'ORDER_MOVED':
    case 'ORDER_STARTED':
    case 'ORDER_STOPPED':
      EventEmitter.emit('ORDER_SOCKET', json)
      break
    default:
      EventEmitter.emit(json.Type, json)
      break
  }
}

if (process.env.NODE_ENV !== 'dev') {
  let FIVE_MINUTES = 60 * 5 * 1000
  let lastLeave = new Date()
  let shouldRefresh = false
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      lastLeave = new Date()
    }
    if (document.visibilityState === 'visible' && window.jQuery('.dropzone').length === 0) {
      shouldRefresh = ((new Date()) - lastLeave) > FIVE_MINUTES
      if (shouldRefresh) {
        window.location.reload(true)
      }
    }
  })
}

// Send ping every 10 sec
setInterval(() => {
  if (window.sock.readyState === window.sock.OPEN) {
    window.sock.send(JSON.stringify({
      Type: 'HEARTBEAT'
    }))
  }
}, 10000)

// Listen on store
let currentValue
function handleChange () {
  let previousValue = currentValue
  currentValue = store.getState().auth.user
  if (!isEqual(previousValue, currentValue)) {
    if (window.sock.readyState === window.sock.OPEN) {
      window.sock.send(JSON.stringify({
        Type: 'RECONNECT',
        ShopId: parseInt(currentValue.ShopId)
      }))
    }
  }
}
store.subscribe(handleChange)

// Axios
import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/json'

// import routes
import routes from './routes'

// import global scss
import './shared/theme/global.scss'

// Language
import {InitLanguage, setTranslations, setLanguage, setLanguages} from './language'
import {
  setPhoneCodes,
  setVehicleLookupServices,
  setBrands,
  setEnums,
  setCountries
} from './actions/common'
InitLanguage().then((res) => {
  // Set translations
  store.dispatch(setTranslations(res.translations))
  store.dispatch(setLanguages(res.langs))

  // Set rest
  store.dispatch(setPhoneCodes(res.data.PhoneCodes))
  store.dispatch(setBrands(res.data.Brands))
  store.dispatch(setEnums(res.data.Enums))
  store.dispatch(setCountries(res.data.Countries))
  store.dispatch(setVehicleLookupServices(res.data.VehicleLookupServices))

  // Set user language
  if (typeof window.localStorage.user_language !== 'undefined') {
    store.dispatch(setLanguage(window.localStorage.user_language))
  }
})

// History
const history = syncHistoryWithStore(browserHistory, store)

// Is user logged in, if accessing embedded booking don't set data from localstorage see AP-3454
if (window.localStorage.user_token && window.localStorage.user_data && !window.location.pathname.startsWith('/embeddedbooking')) {
  if (window.localStorage.loginAsUser && window.localStorage.inactiveUsers) {
    if (JSON.parse(window.localStorage.inactiveUsers).length === 0) {
      window.localStorage.removeItem('inactiveUsers')
      window.localStorage.removeItem('loginAsUser')
      // Normal login
      setAuthorizationToken(window.localStorage.user_token)
      setDeviceToken(JSON.parse(window.localStorage.user_data).DeviceToken)
      store.dispatch(setCurrentUser(JSON.parse(window.localStorage.user_data)))
      if (window.localStorage.department_type === undefined) {
        window.localStorage.setItem('department_type', 0)
      }
      store.dispatch(setDepartmentType(JSON.parse(window.localStorage.department_type)))
    } else {
      // Login as
      setAuthorizationToken(JSON.parse(window.localStorage.loginAsUser).Token)
      setDeviceToken(JSON.parse(window.localStorage.loginAsUser).DeviceToken)
      store.dispatch(setCurrentUser(JSON.parse(window.localStorage.loginAsUser)))
      if (window.localStorage.department_type === undefined) {
        window.localStorage.setItem('department_type', 0)
      }

      store.dispatch(setDepartmentType(JSON.parse(window.localStorage.department_type)))
      store.dispatch({
        type: 'SET_LOGIN_AS',
        inactiveUsers: JSON.parse(window.localStorage.inactiveUsers),
        user: JSON.parse(window.localStorage.loginAsUser)
      })
    }
  } else {
    // Normal login
    setAuthorizationToken(window.localStorage.user_token)
    setDeviceToken(JSON.parse(window.localStorage.user_data).DeviceToken)
    store.dispatch(setCurrentUser(JSON.parse(window.localStorage.user_data)))
    if (window.localStorage.department_type === undefined) {
      window.localStorage.setItem('department_type', 0)
    }
    store.dispatch(setDepartmentType(JSON.parse(window.localStorage.department_type)))
  }
  // Connect to socket
  setTimeout(() => {
    if (window.sock.readyState === window.sock.OPEN) {
      let shopId = JSON.parse(window.localStorage.user_data).ShopId
      if (parseInt(shopId) === 0 && window.localStorage.loginAsUser) {
        shopId = JSON.parse(window.localStorage.loginAsUser).ShopId
      }
      window.sock.send(JSON.stringify({
        Type: 'CONNECTION',
        ShopId: parseInt(shopId)
      }))
    }
  }, 3000)
}

// SET_LOGINTIMER
const setLoginTimer = (store) => {
  let newDate = window.CustomDate()
  if (process.env.NODE_ENV === 'dev') {
    newDate.setSeconds(newDate.getSeconds() + 60 * 10)
  } else {
    let isLoginFromOwner = isLoginFromShopOwner(store.getState().auth.inactiveUsers)
    if (isLoginFromOwner) {
      newDate.setSeconds(newDate.getSeconds() + 120)
    } else {
      newDate.setSeconds(newDate.getSeconds() + 60)
    }
  }
  store.dispatch({
    type: 'SET_LOGINTIMER',
    loginTimer: newDate
  })
}

// COUNTDOWN LOGIN - on mouse click
document.addEventListener('click', () => {
  setLoginTimer(store)
}, true)

// LocalstorageStack
window.LocalstorageStack = {
  all: () => {
    let locations = JSON.parse(window.localStorage.getItem('stack_locations')) || []
    return locations
  },
  top: () => {
    let locations = JSON.parse(window.localStorage.getItem('stack_locations')) || []
    if (locations.length === 0 || locations[locations.length - 2] === undefined) return false
    return locations[locations.length - 2]
  },
  get: (index) => {
    let locations = JSON.parse(window.localStorage.getItem('stack_locations')) || []
    if (locations.length === 0 || locations[locations.length + index] === undefined) return false
    return locations[locations.length + index]
  },
  push: (location) => {
    let locations = JSON.parse(window.localStorage.getItem('stack_locations')) || []
    if (locations.length > 15) locations.shift()
    locations.push(location)
    window.localStorage.setItem('stack_locations', JSON.stringify(locations))
  },
  findFirst: (paths) => {
    let foundItem = null
    let all = window.LocalstorageStack.all()
    if (!all) {
      return foundItem
    }
    all = all.reverse()
    all.map((item) => {
      let indexOfPaths = paths.indexOf(item.pathname)
      if (indexOfPaths !== -1 && foundItem === null) {
        foundItem = item
      }
    })
    return foundItem
  }
}

window.LocalstorageStack.push(window.location)

// history listener
history.listen((location) => {
  // console.log('location', location)
  window.LocalstorageStack.push(location)

  // COUNTDOWN LOGIN
  setLoginTimer(store)
})

// Check loginTimer
setInterval(() => {
  let loginTimer = store.getState().common.loginTimer
  let now = window.CustomDate()
  let diff = (loginTimer.getTime() - now.getTime()) / 1000
  if (diff <= 0) {
    if (typeof store.getState().auth.user.UserType !== 'undefined') {
      if (store.getState().auth.user.UserType === 3 && store.getState().auth.inactiveUsers.length !== 0 && !isLoginFromChainOrSuper(store.getState().auth.inactiveUsers)) {
        // window.localStorage.setItem('workscreen_view', null)
        store.dispatch(logOutAs())
        history.replace('/empty')
        history.replace('/workscreen')
      }
    }
  }
}, 1000)

// Response interceptor - Logout on 401
axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response && error.response.status === 401) {
    if (store.getState().auth.inactiveUsers.length === 0) {
      let bookingPortalUser = store.getState().auth.user.Usage === 1
      store.dispatch(logout())
      if (history.getCurrentLocation().pathname !== '/login') {
        if (!bookingPortalUser) {
          history.replace('/login')
        }
        window.location.reload(true)
      }
    } else {
      store.dispatch(logOutAs(true))
      history.replace('/')
      window.location.reload(true)
    }
  }
  return Promise.reject(error)
})

// DEBOUNCE
window.debounce = (func, wait, immediate) => {
  var timeout
  return function () {
    var context = this
    var args = arguments
    var later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    var callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

// copy text eventListener
// info: https://developer.mozilla.org/en-US/docs/Web/API/Element/copy_event
document.addEventListener('copy', (event) => {
  // let selection = checkCopyText(document.getSelection())
  let selection = checkCopyTextIsRegNumber(getSelectionText())
  event.clipboardData.setData('text/plain', selection.toString())
  event.preventDefault()
  // console.log('Copied the text: ' + selection)
})

const checkCopyTextIsRegNumber = (copyText) => {
  // Regex to find registration number //DC97811
  var regNrRegex = new RegExp(/(^\s*[a-zA-Z]{2})(\s*)(\d{2})(\s*)(\d{3}\s*$)/)
  // remove space if the copy text is a registration number
  if (regNrRegex.test(copyText.toString()) && copyText.toString().replace(/ /g, '').length === 7) {
    // console.log('Reg Match: ' + copyText)
    copyText = copyText.toString().replace(/ /g, '')
  } else {
    // console.log('Reg not Match: ' + copyText)
  }

  return copyText
}

// Since getSelection() doesn't work in firefox input elemnets, we need to get activeElement before we can find the selected text
// info: https://developer.mozilla.org/en-US/docs/Web/API/Document/activeElement
function getSelectionText () {
  var text = ''
  var activeEl = document.activeElement
  var activeElTagName = activeEl ? activeEl.tagName.toLowerCase() : null
  if ((activeElTagName === 'textarea') || (activeElTagName === 'input' && /^(?:text|search|tel|url)$/i.test(activeEl.type)) || (typeof activeEl.selectionStart === 'number')) {
    text = activeEl.value.slice(activeEl.selectionStart, activeEl.selectionEnd)
  } else if (window.getSelection) {
    text = window.getSelection().toString()
  }

  return text
}

// Use to get browser name and add it as class name to the element app.
function addClassName () {
  let element = document.getElementById('app')
  let className = getBrowserName()
  element.classList.add(className)
}

const routesConfig = routes(store)

class App extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      key: 0
    }
  }
  componentDidMount () {
    EventEmitter.addListener('USER_CHANGED_LANG', () => { setTimeout(() => { this.forceUpdate() }, 50) })
    EventEmitter.addListener('FORCE_UPDATE', () => { this.forceReRender() })
    addClassName()
  }

  componentWillUnmount () {
    EventEmitter.removeListener('USER_CHANGED_LANG', () => { setTimeout(() => { this.forceUpdate() }, 50) })
    EventEmitter.removeListener('FORCE_UPDATE', () => { this.forceReRender() })
  }

  // Used to render the entire app again, only when the language resources has updated (some pages was blank until state changed)
  forceReRender () {
    // Timeout is for components to recieve props before rerendering (Workcard recieved undefined in Order and called ReloadPage)
    setTimeout(() => {
      this.setState({ key: Math.random() })
      setLoginTimer(store)
    }, 750)
  }

  render () {
    return (
      <Provider store={store}>
        <div key={this.state.key}>
          <Router history={history} routes={routesConfig} />
          <UploadOverlay />
        </div>
      </Provider>
    )
  }
}

// Render app
render(<App />, document.getElementById('app'))



// WEBPACK FOOTER //
// ./src/app/index.js